import { RootState } from 'redux/reducers'
import { StructureItemType } from 'types/structureType'

export const selectStructure = (state: RootState): StructureItemType[] | null => state.structure.data
export const selectStructureLoading = (state: RootState): boolean => state.structure.isLoading
export const selectStructureError = (state: RootState): boolean => state.structure.error
